import { useEffect } from 'react';
import Hero from './components/Hero';
import Challenges from './components/Challenges';
import Services from './components/Services';
import Strengths from './components/Strengths';
import Benefits from './components/Benefits';
import Flow from './components/Flow';
import FAQ from './components/FAQ';
import CTA from './components/CTA';
import Footer from './components/Footer';

export default function Home() {
  useEffect(() => {
    const handleScroll = () => {
      const navbar = document.querySelector('nav');
      if (navbar) {
        if (window.scrollY > 100) {
          navbar.classList.add('scrolled');
        } else {
          navbar.classList.remove('scrolled');
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <Challenges />
      <Services />
      <Strengths />
      <Benefits />
      <Flow />
      <FAQ />
      <CTA />
      <Footer />
    </div>
  );
}
